module.exports = __webpack_public_path__ + "img/wx-pintuan.e1e4143e.png";